export const SUBTOPIC_TITLE = 'besondere-bewerbung';

export const ParamsTrackingMapper = new Map<string, string>([
  ['overview', 'bewerbung-uebersicht'],
  ['special_application', 'besondere-bewerbung'],
  ['types_and_formats', 'bewerbungsarten-formate'],
  ['cover_letter_tips', 'anschreiben'],
  ['interview_tips', 'vorstellungsgespräch'],
  ['cv_tips', 'lebenslauf'],
]);
